const equipmentcategories = {
	title: "Utstyrskategorier",
	stitle: "Utstyrskategori",
	new_title: "Ny Utstyrskategori",
	edit_title: "Endre utstyrskategori: {name}",
	list_title: "Utstyrskategorier",
	list_subtitle: "Endre utstyrskategorier",
	id: "ID",
	name: "Navn",
	status: "Status",
	reference_id: "Referanse",
};
export default equipmentcategories;